"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { NextIntlClientProvider } from "next-intl";
import { createContext, useCallback, useContext, useEffect, useMemo, useState, } from "react";
import { isAppLocale } from "@/i18n/locales";
import en from "@/messages/en.json";
import pt from "@/messages/pt.json";
import ru from "@/messages/ru.json";
import uk from "@/messages/uk.json";
import uz from "@/messages/uz.json";
const messagesMap = { en, pt, ru, uk, uz };
const LOCALE_KEY = "app_locale";
const DEFAULT_LOCALE = "en";
function getStoredLocale() {
    if (typeof window === "undefined")
        return DEFAULT_LOCALE;
    const v = localStorage.getItem(LOCALE_KEY);
    if (v && isAppLocale(v))
        return v;
    return DEFAULT_LOCALE;
}
const LocaleContext = createContext(null);
export function useLocaleContext() {
    const ctx = useContext(LocaleContext);
    if (!ctx)
        throw new Error("useLocaleContext must be used within IntlProvider");
    return ctx;
}
export function IntlProvider({ children }) {
    const [locale, setLocaleState] = useState(DEFAULT_LOCALE);
    const setLocale = useCallback((l) => {
        setLocaleState(l);
        if (typeof window !== "undefined")
            localStorage.setItem(LOCALE_KEY, l);
    }, []);
    // Hydrate locale from storage on mount
    useEffect(() => {
        setLocaleState(getStoredLocale());
    }, []);
    const messages = useMemo(() => { var _a; return (_a = messagesMap[locale]) !== null && _a !== void 0 ? _a : en; }, [locale]);
    const localeContext = useMemo(() => ({ locale, setLocale }), [locale, setLocale]);
    return (_jsx(LocaleContext.Provider, { value: localeContext, children: _jsx(NextIntlClientProvider, { locale: locale, messages: messages, children: children }) }));
}
